import React, { useState, useEffect, useCallback, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment';
import { InputItem, ActionSheet, Grid } from 'antd-mobile'
import { Radios } from '../components'
import CompanyList from '../components/CompanyList'
import { UpgradeStatus } from '../utils/const'
import { GetCompanyList } from "../../../api/usms";
// import { GetSelfPermissions } from "../../../api/acl";
import { AclKeys } from '../utils/permissions';
import Permission from '../components/Permission';
import BasicContext from '../BasicContext';

const WaitUpgrade = ['赠金发放', '赠金取消', '账户充值', '信用额度充值', '账户升级', '取消'];
const Upgraded = ['赠金发放', '赠金取消', '账户充值', '信用额度充值', '取消'];

function List(props) {
  const context = useContext(BasicContext);
  const permissions = context.permissions || [];
  const userInfo = context.userInfo || {};

  const [purpose, setPurpose] = useState("All")
  const [companyInput, setCompanyInput] = useState("")
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [allCompanyList, setAllCompanyList] = useState([]);
  const [showData, setShowData] = useState([{
    text: '总用户数',
    total: 0
  }, {
    text: '今日注册数',
    total: 0,
  }, {
    text: '已升级',
    total: 0,
  }])
  const { history } = props;

  const computeUserCount = useCallback((allCompanyList) => {
    let data = []
    const Total = {
      text: '总用户数',
      total: allCompanyList.length
    }
    const endTime = moment().unix();
    const startTime = moment().startOf('day').unix()
    const list = allCompanyList.filter(item => item.RegistrationTime > startTime && item.RegistrationTime < endTime)

    const TodayTotal = {
      text: '今日注册数',
      total: list.length,
    }
    const upgradeList = allCompanyList.filter(item => item.Upgrade === 1)
    const UpgradeTotal = {
      text: '已升级',
      total: upgradeList.length,
    }
    data.push(Total, TodayTotal, UpgradeTotal)
    return data
  }, [])

  const onSearch = useCallback((val) => {
    if (val) {
      searchList({
        upgrade: purpose,
        searchValue: String(val)
      })
    } else {
      searchList({
        upgrade: purpose,
        searchValue: ''
      })
    }
    setCompanyInput(val)
  }, [allCompanyList])

  const handleStatus = useCallback((value) => {
    setPurpose(value)
    searchList({
      upgrade: value,
      searchValue: companyInput
    })
  }, [companyInput, allCompanyList])

  const getList = useCallback((data) => {
    const params = {
      UpgradeStatue: purpose === 'All' ? undefined : purpose,
      ...data,
    }
    setLoading(true);
    GetCompanyList(params).then(res => {
      const { Data } = res;
      if (Data) {
        // USMS产品运营 
        const isfilterPerimission = permissions.some(item => item.resource === AclKeys.isCompanyListUseFilter);
        // 过滤销售人员, 超管除外
        let data = Data || [];
        if (isfilterPerimission) {
          console.log('通过销售人员过滤对应的客户', userInfo.user);
          data = (Data || [])
            .filter(item => (item.SalespersonName + '').indexOf(userInfo.user) > -1);
        }
        setAllCompanyList(data);
        setCompanyList(data);
        const result = computeUserCount(data)
        setShowData(result)
      } else {
        setErrorMessage("获取用户信息失败")
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }, []);

  const handleAction = (value) => {
    let BUTTONS = value.Upgrade === 1 ? Upgraded : WaitUpgrade;
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      // destructiveButtonIndex: BUTTONS.length - 2,
      // title: 'title',
      message: `当前操作用户 ${value.Email}`,
      maskClosable: true,
      'data-seed': 'logId',
      // wrapProps,
    },
      (buttonIndex) => {
        if (value.Upgrade === 1 && buttonIndex === BUTTONS.length - 1) {
          return
        } else {
          handleSelectAction(buttonIndex, value)
        }
      });
  }

  const handleSelectAction = (index, value) => {
    switch (index) {
      case 0: history.push(`/usms/addfree?CompanyId=${value.CompanyId}`); break;
      case 1: history.push(`/usms/cancelfree?CompanyId=${value.CompanyId}&Type=cancel`); break;
      case 2: history.push(`/usms/addtrade?CompanyId=${value.CompanyId}`); break;
      case 3: history.push(`/usms/credit?CompanyId=${value.CompanyId}`); break;
      case 4: history.push(`/usms/upgrade?CompanyId=${value.CompanyId}`); break;
      // case 2: showAlert(value); break;
      default: ; break;
    }
  }

  const searchList = useCallback(({
    upgrade,
    searchValue
  }) => {
    // 前端模糊筛选逻辑，指定筛选字段CompanyId, Email
    const list = JSON.parse(JSON.stringify(allCompanyList))
    const search = list.filter(item => {
      const Email = item.Email || ""
      const CompanyId = String(item.CompanyId) || ""
      if (!searchValue && upgrade !== "All") {
        return item.Upgrade === (upgrade === "Disable" ? 0 : 1)
      } else if (upgrade === "All") {
        return Email.indexOf(searchValue) > -1 || CompanyId.indexOf(searchValue) > -1
      } else {
        return (Email.indexOf(searchValue) > -1 || CompanyId.indexOf(searchValue) > -1) && item.Upgrade === (upgrade === "Disable" ? 0 : 1)
      }
    })
    setCompanyList(search)
  }, [allCompanyList])

  useEffect(() => {
    getList()
  }, [])

  return <div className="container">
    <Permission aclKey={AclKeys.AllUserManage}>
      <div style={{ marginBottom: '8px' }}>
        <span>账户状态：</span>
        <Radios
          value={purpose}
          style={{ whiteSpace: 'nowrap' }}
          onChange={value => handleStatus(value)}
          options={Object.keys(UpgradeStatus).map(item => ({ label: UpgradeStatus[item], value: item }))} />
      </div>
      <div style={{ marginBottom: '10px' }}>
        <InputItem
          size="small"
          placeholder="模糊搜索公司邮箱或公司ID"
          value={companyInput}
          onChange={onSearch}>搜索</InputItem>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <Grid data={showData}
          columnNum={3}
          activeStyle={false}
          itemStyle={{ height: '80px' }}
          renderItem={dataItem => {
            return <div>
              <div>{dataItem.total}</div>
              <div>{dataItem.text}</div>
            </div>
          }}
        />
      </div>
      <div>
        <CompanyList
          loading={loading}
          errorMessage={errorMessage}
          companyList={companyList}
          handleAction={handleAction}
        />
      </div>
    </Permission>
  </div>
}

export default withRouter(List)